// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://bxhnxfwrumeqvnpwymin.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJ4aG54ZndydW1lcXZucHd5bWluIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM0NDI5MDUsImV4cCI6MjA2OTAxODkwNX0.YXWu3lJQkUfo7PLe1NlYy3yTMIUH4SWS_bHcwpG_na0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});